import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "stylesheet-editor" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MonacoWrapper = _resolveComponent("MonacoWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MonacoWrapper, {
      modelValue: _ctx.cssString,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.cssString = $event)),
      class: "editor",
      language: "css",
      adjustToContent: true
    }, null, 8, ["modelValue"])
  ]))
}